import { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement>;

export default function ExpandMoreIcon(props: Props) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none"  xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M10.5832 6.00005L7.99657 8.58672L5.4099 6.00005C5.1499 5.74005 4.7299 5.74005 4.4699 6.00005C4.2099 6.26005 4.2099 6.68005 4.4699 6.94005L7.5299 10.0001C7.7899 10.2601 8.2099 10.2601 8.4699 10.0001L11.5299 6.94005C11.7899 6.68005 11.7899 6.26005 11.5299 6.00005C11.2699 5.74672 10.8432 5.74005 10.5832 6.00005Z"
        fill="currentColor"
      />
    </svg>
  );
}
